import { DeviceDetector } from '@/utils/device-detector';
import { AppHeader } from '@/components/header';
import { AppFooter } from '@/components/footer';
import { storeLogos } from '@/assets/logo';

export default {
  name: 'app-body',
  components: {
    AppFooter,
    AppHeader
  },
  props: {
    appTitle: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      storeLogos: storeLogos(),
      isMobile: DeviceDetector.isMobile(),
      qrSrc: '//st.bork.ru/app-bork-ru/qr.jpg',
      isIos: DeviceDetector.isIos()
    };
  },
  methods: {
    getClass(item) {
      return {
        'app-body__logos--hidden': this.isMobile && item.isHiddenInMobile,
        'app-body__logos--disabled': !item.isClickable
      };
    }
  }
};
